document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('NewsletterPopup');
  if (!popup) return;

  const storageKey = 'newsletter_popup_closed';
  const delayInSeconds = Number(popup.dataset.delay || 3);
  const delay = delayInSeconds * 1000;
  const closeButton = popup.querySelector('.newsletter-popup__close');
  let previouslyFocused = null;

  if (window.localStorage.getItem(storageKey) === 'true') return;

  const openPopup = function () {
    previouslyFocused = document.activeElement;
    popup.classList.add('newsletter-popup--visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeButton?.focus();
  };

  const closePopup = function () {
    popup.classList.remove('newsletter-popup--visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.localStorage.setItem(storageKey, 'true');
    if (previouslyFocused?.isConnected) previouslyFocused.focus();
  };

  window.setTimeout(openPopup, delay);

  popup.querySelector('.newsletter-popup__close')?.addEventListener('click', closePopup);
  popup.querySelector('.newsletter-popup__overlay')?.addEventListener('click', closePopup);
  document.addEventListener('keydown', function (event) {
    if (!popup.classList.contains('newsletter-popup--visible')) return;
    if (event.key === 'Tab') {
      const items = [...popup.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])')].filter(el => !el.disabled && el.getClientRects().length);
      const first = items[0];
      const last = items[items.length - 1];
      if (!first) return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    if (event.key === 'Escape' && popup.classList.contains('newsletter-popup--visible')) {
      closePopup();
    }
  });
});
